import React from 'react';

interface Props {
  width: number;
  height: number;
}

function AllCaughtUpCheckIcon(props: Props) {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#22C55E"
        fillRule="evenodd"
        d="M12 21.6c5.302 0 9.6-4.298 9.6-9.6S17.302 2.4 12 2.4 2.4 6.698 2.4 12s4.298 9.6 9.6 9.6zm4.448-11.151a1.201 1.201 0 00-1.697-1.698L10.8 12.703l-1.551-1.551a1.201 1.201 0 00-1.698 1.697l2.4 2.4c.47.468 1.229.468 1.698 0l4.8-4.8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

AllCaughtUpCheckIcon.defaultProps = {
  width: '24',
  height: '24'
};

export { AllCaughtUpCheckIcon };
